import React, { useEffect } from "react"
import Loader from "../../Helper/Loaders/Loader"
import { usePageMeta } from "../../Hooks/usePageMeta"
import { BatteryHealthLoaderBox, PageContainer } from "../../Components/CustomBox"
import { NotificationProvider } from "../../Hooks/useNotification"
import AlertAnalyticsMain from "./AlertAnalyticsMain"

function AlertAnalytics(props) {
  const { pagesContent } = usePageMeta("alertAnalytics");

  useEffect(() => {
    pagesContent["mounted"] = true
  }, [pagesContent])

  return (
    <PageContainer>
      {pagesContent?.mounted ? (
        <NotificationProvider>
          <AlertAnalyticsMain pagesContent={pagesContent} />
        </NotificationProvider>
      ) : (
        <BatteryHealthLoaderBox>
          <Loader />
        </BatteryHealthLoaderBox>
      )}
    </PageContainer>
  )
}

export default AlertAnalytics
